export const getNextSegment = (segments, index) => { var _a; return (_a = segments[index + 1]) === null || _a === void 0 ? void 0 : _a.segment; };
export const getCheapestFlightInCombination = (fares, selectedFares) => {
    var _a, _b, _c, _d, _e, _f;
    if (selectedFares.length === 0) {
        return (_b = (_a = fares.prices) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : null;
    }
    const lastSelectedFare = selectedFares[selectedFares.length - 1];
    const lastSelectedFareMap = new Map();
    (_c = lastSelectedFare === null || lastSelectedFare === void 0 ? void 0 : lastSelectedFare.prices) === null || _c === void 0 ? void 0 : _c.forEach(price => {
        var _a;
        if (((_a = price.flight) === null || _a === void 0 ? void 0 : _a.id) && price.price) {
            lastSelectedFareMap.set(price.flight.id, price.price.amount);
        }
    });
    let minSum = Infinity;
    let minPrice = (_e = (_d = fares.prices) === null || _d === void 0 ? void 0 : _d[0]) !== null && _e !== void 0 ? _e : null;
    (_f = fares.prices) === null || _f === void 0 ? void 0 : _f.forEach(price => {
        var _a;
        if (((_a = price === null || price === void 0 ? void 0 : price.flight) === null || _a === void 0 ? void 0 : _a.id) && (price === null || price === void 0 ? void 0 : price.price) && lastSelectedFareMap.has(price.flight.id)) {
            const totalAmount = price.price.amount + lastSelectedFareMap.get(price.flight.id);
            if (totalAmount < minSum) {
                minSum = totalAmount;
                minPrice = price;
            }
        }
    });
    return minPrice;
};
